import generateUtilityClass from '../generateUtilityClass';
export default function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
// module id = 1712
// module chunks = 25